// ============================================================
// 產品分享短碼：id <-> 3 位英文數字混合碼（/p/{code}）
// 仿射可逆映射（mod 31^3），冇 DB 查表：同一 id 永遠得同一短碼。
// 字元集排除易混淆的 i/l/o/0/1；僅作美觀與隱匿產品流水號，非安全機制。
// ============================================================

const M = 31 ** 3; // 29791
const A = 1000; // 乘數（不可為 31 的倍數）
const B = 7919; // 偏移
const INV_A = 20526; // A^-1 mod M（預先計算）
export const SHARE_CODE_ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';

/** 產品 id -> 3 位短碼（例：5 -> 'qq2'） */
export function encodeShareId(id: number): string {
  const x = (((A * Math.floor(id)) + B) % M + M) % M;
  return (
    SHARE_CODE_ALPHABET[Math.floor(x / 961) % 31] +
    SHARE_CODE_ALPHABET[Math.floor(x / 31) % 31] +
    SHARE_CODE_ALPHABET[x % 31]
  );
}

/** 3 位短碼 -> 產品 id（無效字元回 null） */
export function decodeShareId(code: string): number | null {
  const c = code.toLowerCase();
  if (!/^[a-hj-km-np-z2-9]{3}$/.test(c)) return null;
  const x =
    SHARE_CODE_ALPHABET.indexOf(c[0]) * 961 +
    SHARE_CODE_ALPHABET.indexOf(c[1]) * 31 +
    SHARE_CODE_ALPHABET.indexOf(c[2]);
  if (x < 0 || x >= M) return null;
  const n = ((((x - B) * INV_A) % M) + M) % M;
  return n === 0 ? null : n;
}

/** 產品短連結（例：https://kare-tech.pages.dev/p/qq2） */
export function buildProductShareUrl(origin: string, productId: number): string {
  return `${origin}/p/${encodeShareId(productId)}`;
}
